import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DocTemplateLogo } from 'src/app/shared/enums/EnumsVMS';
import SignaturePad from 'signature_pad';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
var htmlToPdfmake = require("html-to-pdfmake");
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DatePipe } from '@angular/common';
import { VendorOnboardingService } from '../../services/vendor-onboarding-service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-ctoccompany-onboardingdocument-nca',
  templateUrl: './ctoccompany-onboardingdocument-nca.component.html',
  styleUrls: ['./ctoccompany-onboardingdocument-nca.component.css'],
  providers: [DialogService, MessageService, ConfirmationService],
})
export class CtoccompanyOnboardingdocumentNcaComponent implements OnInit {
  
  signFormNCA!: FormGroup;
  logoOnLeft :string = DocTemplateLogo.DevCareLogo;
  logoOnRight: string = DocTemplateLogo.CMMIISOLogo;
  NCATemplateOnAccordion;
  applicantName: any;
  ncaFormUploadedPath: any;
  hasNCACompleted: boolean = false;
  isSignatureTabNCA: boolean = false;
  isTextTabNCA: boolean = true;
  isImageUploadTabNCA: boolean = false;
  showNCAAccordion: boolean = false;
  sigNCA!: SignaturePad;
  imageUrlNCASign: any;
  showNCAGenerateButton: boolean = true;
  imageUploadedPathNCASign: string;
  splittedImageUploadedPathNCASign: string[];
  fileToUploadNCASign: any;
  imageFileNCASign: string;
  defaultImageNCASign = "pi pi-user";
  uploadImageNCASign: any = "";
  uploadedFileNCASign: File;
  imgBase64Path;
  NCAIAgreeAboveTerms: boolean = false;

  msaTypeIdOnEdit: number = 0;
  emailLinkRefId: string;
  documentTypeOnFileUpload: string;
  templatePaymentTermsId: string;
  msaTypeId: number;
  companyProfileAndOnboardingDocumentPageTitle: string;
  insuranceExhibitA: number;
  submittedByEmail: any;
  tempVendorId: any;
  loadingSaveButton: boolean = false;
  loadingUploadButton: boolean = false;
  saveModal:boolean = false;
  linkSharedEmailId: any;
  createdBy: any;
  commentsControl = new FormControl("", this.editorMaxLength(500));
  // emailValidity: any;
  alreadySubmittedModal: boolean = false;
  emailLinkExpiredModal: boolean = false;
  showGenerateButton: boolean = false;
  imageUrl: any;
  defaultImage = "pi pi-user";
  fileToUpload: any;
  uploadedFileMSA: File;
  NCATemplateOnBrowser;
  blobFile;
  hrSign = 'data:image/png;base64,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';
  uploadedNCAFile: File;
  @ViewChild("canvasNCA", { static: true }) canvasNCA!: ElementRef;
  penColor = 'rgba(0,0,0,1)';


  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public datepipe: DatePipe,
    private vendoronboardingService: VendorOnboardingService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {

    const param = this.route.snapshot.paramMap.get('emailLinkRefId');
    // const param1 = this.route.snapshot.paramMap.get('linkSharedEmailId');
    if (param) {
      // this.emailLinkRefId = param;
      // this.linkSharedEmailId = param1;
      // this.getVendorOnboardDetails();
      const partEmailLinkRefId  = param.split('_');
      if(partEmailLinkRefId.length >= 2){
        this.emailLinkRefId = partEmailLinkRefId[0] + '_';
        this.linkSharedEmailId = partEmailLinkRefId[1];
        this.getVendorOnboardDetails();
        console.log('part 0', this.emailLinkRefId);
        console.log('part 1', this.linkSharedEmailId);
      }
     
    this.vendoronboardingService.getCheckApplicantEmailValidity(this.emailLinkRefId).subscribe((data:any)=> {
      // this.emailValidity = data;
      console.log('email validity',data);
      if(data.isError == true && data.result == "EmailLink Reference Id is not available"){
        // this.router.navigate(['/login']);
        this.alreadySubmittedModal = true;
      }
      else if(data.isError == true && data.result == "Already Submitted by VendorOnboardProcess"){
        this.alreadySubmittedModal = true;
      }
      else if(data.isError == true && data.result == "EMail link Expired by VendorOnboardProcess"){
        this.emailLinkExpiredModal = true;
      }
      // else{
      // }
      });

    }
    this.getVendorOnboardDetails();
    this.signFormNCA = this.formBuilder.group({
      applicantName: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      // title: new FormControl('', [Validators.required]),
      signText: new FormControl(''),
    });

    this.sigNCA = new SignaturePad(this.canvasNCA.nativeElement, {
      penColor: this.penColor, minWidth: 1,
      maxWidth: 2
    });
  }

  getVendorOnboardDetails() {
    // this.emailLinkRefId = 'VNDMMmi16202307496K712J824ZVH4_';
    this.vendoronboardingService.GetVendorOnboardProcess(this.emailLinkRefId).subscribe((value: any) => {
      if(value.ncaDocumentTemplate != undefined || value.ncaDocumentTemplate != null){
        this.NCATemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(value.ncaDocumentTemplate.generatedTemplate);
        this.NCATemplateOnBrowser =value.ncaDocumentTemplate.generatedTemplate;
        this.createdBy = value.createdBy;
        this.tempVendorId = value.tempVendorId;
        this.applicantName=value.applicantName;
      }
    });
  }
  handleChangeNCA(e){
    // if(e.index == 0){
    //   this.isSignatureTabNCA = true;
    //   this.isTextTabNCA = false;
    //   this.isImageUploadTabNCA = false;
    // }
    if(e.index == 0){
      this.isTextTabNCA = true;
      this.isSignatureTabNCA = false;
      this.isImageUploadTabNCA = false;
    }
    if(e.index == 1){
      this.isTextTabNCA = false;
      this.isSignatureTabNCA = false;
      this.isImageUploadTabNCA = true;
    }
  }

  clearNCASign() {
    this.sigNCA.clear();
  }
  
  undoNCASign() {
    var data = this.sigNCA.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.sigNCA.fromData(data);
    }
  }

  onImageSelectNCASign(event, file: FileList) {
    this.imageFileNCASign = event.target.value;
    this.imageFileNCASign = this.imageFileNCASign.split('\\').pop().split('/').pop();
    if (this.imageFileNCASign.split('.').pop() == 'png' || this.imageFileNCASign.split('.').pop() == 'jpg' || this.imageFileNCASign.split('.').pop() == 'jpeg') {
      this.fileToUploadNCASign = file.item(0);
      //For Image Preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrlNCASign = event.target.result;
      }
      //console.log(this.fileToUpload);
      reader.readAsDataURL(this.fileToUploadNCASign);
      this.uploadImageFileNCASign();
      this.defaultImageNCASign = "";
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select valid file format (png,jpg,jpeg)' });
    }
  }

  @ViewChild('imageUploadNCASign') imagefileInputNCASign;
uploadImageFileNCASign(): void {
  let fi = this.imagefileInputNCASign.nativeElement;
  if (fi.files && fi.files[0]) {
    this.uploadedFileNCASign = fi.files[0];
    if(this.uploadedFileNCASign .size> 1e+6)
    {
        //alert('1');
    }
    else{
      //alert('2');
    }
    var reader = new FileReader();
    reader.onload = (event:any) => 
    {
        this.imgBase64Path = event.target.result;
        // console.log(this.imgBase64Path);
    }
    reader.readAsDataURL(fi.files[0]);
  }
}

  isBoldOpenNCA = (arrayLength: any, valueBefore = false) => {
    const isEven = arrayLength % 2 === 0;
    const result = valueBefore !== isEven;

    return result;
  }


  onChangeNCAIAgreeAboveTerms(value) {
    this.NCAIAgreeAboveTerms = value.checked;
    // console.log('this.NCAIAgreeAboveTerms - ' + this.NCAIAgreeAboveTerms);
  }

  downloadNCAPDF() {
     this.loadingSaveButton = true;
    if (this.isSignatureTabNCA == true) {
      if (this.sigNCA.isEmpty() == true) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please sign the document' });
        this.loadingSaveButton = false;
      }
      else if (this.sigNCA.isEmpty() == false) {
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        // {
        //   text: this.signFormMSA.controls['name'].value,
        //   font: 'cedarvillecursiveFont',
        //   fontSize: 15,
        // },
        {
          image: 'userSignImage',
          width: '120'
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
  //  const url = URL.createObjectURL(blob);
  //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     //this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     //debugger;
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     //this.loadingSaveButton = false;
     this.submitCompanyProfileAndVendorOnboardDetails();
     //this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  

  }
}
else if(this.isTextTabNCA == true){
  if (this.signFormNCA.controls['signText'].value == '') {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please add text' });
    this.loadingSaveButton = false;
  }
  else{
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
//let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        {
          text: this.signFormNCA.controls['signText'].value,
          font: 'cedarvillecursiveFont',
          fontSize: 15,
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    //userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
      // const url = URL.createObjectURL(blob);
      // window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     //this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     //this.loadingSaveButton = false;
     this.submitCompanyProfileAndVendorOnboardDetails();
     //this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  }
}

else if(this.isImageUploadTabNCA == true){
  if (this.imgBase64Path == undefined) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload image' });
    this.loadingSaveButton = false;
  }
  else if (this.imgBase64Path !== undefined) {
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
//let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        // {
        //   text: this.signFormMSA.controls['name'].value,
        //   font: 'cedarvillecursiveFont',
        //   fontSize: 15,
        // },
        {
          image: 'userSignImage',
          width: '120'
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    userSignImage: this.imgBase64Path,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
    //  const url = URL.createObjectURL(blob);
    //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     //this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     //this.loadingSaveButton = false;
     this.submitCompanyProfileAndVendorOnboardDetails();
    // this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  }
}


}

editorMaxLength(maxlength): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var regex = /(<([^>]+)>)/ig;
    var value = control.value;
    if (value == null) {
      return null;
    }
    var result = value.replace(regex, "");
    if (result.length > maxlength) {
      return { 'maxlengthError': true };
    }else{
      return null;
    }
  }
}

submitCompanyProfileAndVendorOnboardDetails() {
  // console.log(this.msaFormUploadedPath, this.poFormUploadedPath, this.ncaFormUploadedPath, this.ddFormUploadedPath, this.voidChequeFormUploadedPath
  //   , this.InsuranceUploadedPathRequest, this.w9FormUploadedPath, this.i9FormUploadedPath, this.everificationFormUploadedPath);
  const vendorOnboardDetails:any = {
    isActive:true,
    createdBy: this.createdBy,
    createdOn: new Date(),
    modifiedOn: new Date(),
    tempVendorId: this.tempVendorId,
    emailLinkRefId: this.emailLinkRefId,
    modifiedBy: 1,
    submittedByEmail: this.linkSharedEmailId,
    statusId:0,
    comments: (this.commentsControl.value == null ? null : this.commentsControl.value),
    ncaTemplateTypeId:0,
    ncaDocTemplate:this.NCATemplateOnBrowser,
    hasNCAStepCompleted:this.hasNCACompleted,
    ncaDocumentDetails: { customFileName: this.ncaFormUploadedPath  },
  };
  // console.log(vendorOnboardDetails);
  this.vendoronboardingService.SubmitVendorOnboardDetailsApplicant(vendorOnboardDetails).subscribe((data:any)=>{
    // this.router.navigateByUrl('/login');
    this.commentsControl.setValue('');
    this.saveModal=true;
     this.loadingSaveButton = false;
  });
  // this.confirmationService.confirm({
  //   key:'submitSucessDialog',
  //   header:'Confirmation - Onboarding Details Submitted',
  //   message:'The details have been submitted successfully. Our accounts team will verify your details and respond once approved or provide with further details',
  //   accept: () => {
  //     console.log('this');
  //     this.router.navigateByUrl('/login');
  //   }, reject:() =>{
  //     this.router.navigateByUrl('/login');
  //   }
  // })
}

saveRedirect() {
  setTimeout(() => {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
    this.router.navigate(['/login']);
  }, 1000);
}
}
